(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const revealInitialized = new WeakSet();

    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initFooterDecoReveal = (root) => {
      if (revealInitialized.has(root)) return;
      revealInitialized.add(root);

      if (prefersReducedMotion()) {
        root.classList.add('is-in-view');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-in-view');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[entries.length - 1];
          if (!entry?.isIntersecting || entry.intersectionRatio < 0.2) return;
          root.classList.add('is-in-view');
          observer.disconnect();
        },
        { threshold: [0, 0.2, 0.35], rootMargin: '0px 0px -5% 0px' }
      );

      observer.observe(root);
    };

    const initAll = () => {
      const roots = document.querySelectorAll('[data-footer-deco]');
      for (const root of roots) {
        initFooterDecoReveal(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    const handleSectionUpdate = (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      const roots = event.target.querySelectorAll('[data-footer-deco]');
      if (roots.length === 0) return;

      for (const root of roots) {
        revealInitialized.delete(root);
        root.classList.remove('is-in-view');
        initFooterDecoReveal(root);
      }
    };

    document.addEventListener('shopify:section:load', handleSectionUpdate);
    document.addEventListener('shopify:section:reorder', handleSectionUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-scroll-navigation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initialized = new WeakSet();

    const initStripDrag = (root) => {
      const strips = root.querySelectorAll('[data-parfum-strip]');
      for (const strip of strips) {
        if (initialized.has(strip)) continue;
        initialized.add(strip);

        let isDown = false;
        let startX = 0;
        let scrollStart = 0;
        let movedDistance = 0;

        strip.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') return;
          if (event.target.closest('[data-accordion-trigger], a, button')) return;
          isDown = true;
          movedDistance = 0;
          startX = event.clientX;
          scrollStart = strip.scrollLeft;
          strip.setPointerCapture?.(event.pointerId);
        });

        strip.addEventListener('pointermove', (event) => {
          if (!isDown) return;
          const delta = event.clientX - startX;
          movedDistance = Math.abs(delta);
          if (movedDistance > 4) strip.classList.add('is-dragging');
          strip.scrollLeft = scrollStart - delta;
        });

        const endDrag = (event) => {
          if (!isDown) return;
          isDown = false;
          strip.releasePointerCapture?.(event.pointerId);
          if (strip.classList.contains('is-dragging')) {
            requestAnimationFrame(() => strip.classList.remove('is-dragging'));
          }
        };

        strip.addEventListener('pointerup', endDrag);
        strip.addEventListener('pointercancel', endDrag);
        strip.addEventListener('pointerleave', endDrag);
      }
    };

    const initAccordions = (root) => {
      const transitionDuration = 300;
      const wrappers = Array.from(root.querySelectorAll('[data-accordion-wrapper]'));
      const accordions = [];

      for (let index = 0; index < wrappers.length; index++) {
        const wrapper = wrappers[index];
        if (initialized.has(wrapper)) continue;
        initialized.add(wrapper);

        const card = wrapper.querySelector('[data-accordion]');
        const trigger = card?.querySelector('[data-accordion-trigger]');
        const content = card?.querySelector('.parfum-accordion__content');
        if (!card || !trigger || !content) continue;

        const uniqueId = 'parfum-accordion-content-' + index + '-' + Math.random().toString(16).slice(2);
        content.id = uniqueId;
        trigger.setAttribute('aria-controls', uniqueId);

        const scrollContainer = card.closest('[data-parfum-strip]');
        let closeTimeout = null;

        const lockWrapperSize = () => {
          if (card.classList.contains('is-floating')) return;
          wrapper.style.minHeight = card.offsetHeight + 'px';
          wrapper.style.minWidth = card.offsetWidth + 'px';
        };

        lockWrapperSize();
        window.addEventListener('resize', lockWrapperSize);

        const positionFloatingCard = () => {
          const rect = wrapper.getBoundingClientRect();
          card.style.top = rect.top + 'px';
          card.style.left = rect.left + 'px';
          card.style.minWidth = rect.width + 'px';
        };

        const accordion = { card, trigger };

        const handleOutsidePointer = (event) => {
          if (!card.contains(event.target)) {
            closeAccordion();
          }
        };

        const handleEscape = (event) => {
          if (event.key === 'Escape') {
            closeAccordion();
            trigger.focus();
          }
        };

        const handleReposition = () => {
          positionFloatingCard();
        };

        const detachDismissListeners = () => {
          document.removeEventListener('pointerdown', handleOutsidePointer);
          document.removeEventListener('keydown', handleEscape);
          window.removeEventListener('scroll', handleReposition);
          window.removeEventListener('resize', handleReposition);
          if (scrollContainer) {
            scrollContainer.removeEventListener('scroll', handleReposition);
          }
        };

        const closeOthers = () => {
          for (const other of accordions) {
            if (other !== accordion && other.card.classList.contains('is-open')) {
              other.close();
            }
          }
        };

        const openAccordion = () => {
          closeOthers();
          if (closeTimeout) {
            clearTimeout(closeTimeout);
            closeTimeout = null;
          }
          lockWrapperSize();
          positionFloatingCard();
          card.classList.add('is-floating', 'is-open');
          trigger.setAttribute('aria-expanded', 'true');
          window.addEventListener('scroll', handleReposition, { passive: true });
          window.addEventListener('resize', handleReposition);
          if (scrollContainer) {
            scrollContainer.addEventListener('scroll', handleReposition, { passive: true });
          }
          requestAnimationFrame(() => {
            document.addEventListener('pointerdown', handleOutsidePointer);
            document.addEventListener('keydown', handleEscape);
          });
        };

        const closeAccordion = () => {
          if (!card.classList.contains('is-open')) return;
          card.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          detachDismissListeners();
          closeTimeout = setTimeout(() => {
            card.classList.remove('is-floating');
            card.style.top = '';
            card.style.left = '';
            card.style.minWidth = '';
            closeTimeout = null;
          }, transitionDuration);
        };

        accordion.open = openAccordion;
        accordion.close = closeAccordion;
        accordions.push(accordion);

        trigger.addEventListener('click', () => {
          if (card.classList.contains('is-open')) {
            closeAccordion();
          } else {
            openAccordion();
          }
        });
      }
    };

    const initAll = () => {
      const roots = document.querySelectorAll('[data-scroll-nav-section]');
      for (const root of roots) {
        initStripDrag(root);
        initAccordions(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      if (event.target.querySelector('[data-scroll-nav-section]')) initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wrap = document.getElementById('password-newsletter');
    if (!wrap) return;

    const params = new URLSearchParams(window.location.search);
    const fromCustomerForm = params.get('form_type') === 'customer';
    const err = wrap.querySelector('[id^="PasswordPageEmail-error-"]');
    const ok = wrap.querySelector('[id^="PasswordPageEmail-success-"]');
    const refreshKey = 'password-newsletter-customer-refresh';

    window.addEventListener(
      'pageshow',
      (event) => {
        if (event.persisted) {
          window.location.reload();
        }
      },
      { passive: true }
    );

    if (fromCustomerForm && !err && !ok) {
      if (!sessionStorage.getItem(refreshKey)) {
        sessionStorage.setItem(refreshKey, '1');
        window.location.reload();
        return;
      }
      sessionStorage.removeItem(refreshKey);
    } else if (err || ok) {
      sessionStorage.removeItem(refreshKey);
    }

    const message = err || ok;
    if (!(message instanceof HTMLElement)) return;

    requestAnimationFrame(() => {
      message.focus();
      message.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  })();

  (() => {
    const wrap = document.querySelector('.barron-squeeze');
    const ziel = document.getElementById('bestaetigt');
    if (!wrap || !ziel || window.location.hash !== '#bestaetigt') return;
    wrap.classList.add('barron-squeeze-zustand-bestaetigt');
    const widget = ziel.querySelector('.barron-squeeze-danke-widget');
    const nachOben = () => {
      window.scrollTo(0, 0);
      if (widget) widget.focus({ preventScroll: true });
    };
    requestAnimationFrame(nachOben);
    window.addEventListener('load', () => setTimeout(nachOben, 0), { once: true });
  })();

  (() => {
    const wrap = document.querySelector('.barron-squeeze');
    if (!wrap) return;

    // Rechtstexte per Adresse erreichbar: /password#barron-squeeze-datenschutz bzw. #barron-squeeze-impressum (Meta braucht eine aufrufbare Datenschutz-URL).
    const perAdresse = () => {
      const id = window.location.hash.slice(1);
      if (!id) return;
      const overlay = document.getElementById(id);
      if (overlay && overlay.classList.contains('barron-squeeze-overlay') && typeof overlay.showModal === 'function' && !overlay.open) {
        overlay.showModal();
      }
    };
    perAdresse();
    window.addEventListener('hashchange', perAdresse);

    wrap.addEventListener('click', (event) => {
      const oeffner = event.target.closest('[data-barron-squeeze-open]');
      if (oeffner) {
        const overlay = document.getElementById(oeffner.getAttribute('data-barron-squeeze-open'));
        if (overlay && typeof overlay.showModal === 'function' && !overlay.open) {
          overlay.showModal();
        }
        return;
      }

      const schliesser = event.target.closest('[data-barron-squeeze-close]');
      if (schliesser) {
        const overlay = schliesser.closest('dialog');
        if (overlay) overlay.close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-about-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initialized = new WeakSet();
    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const revealAll = (root) => {
      for (const el of root.querySelectorAll('[data-reveal]')) el.classList.add('is-in-view');
    };

    const initReveal = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);

      if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
        revealAll(root);
        return;
      }

      const observer = new IntersectionObserver(
        (entries, obs) => {
          for (const entry of entries) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
              entry.target.classList.add('is-in-view');
              obs.unobserve(entry.target);
            }
          }
        },
        { threshold: [0, 0.1, 0.2], rootMargin: '0px 0px -8% 0px' }
      );

      for (const el of root.querySelectorAll('[data-reveal]')) observer.observe(el);
    };

    const initAll = () => {
      for (const root of document.querySelectorAll('[data-us-about-page]')) initReveal(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    const handleSectionUpdate = (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      const roots = event.target.querySelectorAll('[data-us-about-page]');
      for (const root of roots) {
        initialized.delete(root);
        revealAll(root);
        initReveal(root);
      }
    };

    document.addEventListener('shopify:section:load', handleSectionUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const revealInitialized = new WeakSet();

    const prefersReducedMotion = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initAboutReveal = (root) => {
      if (revealInitialized.has(root)) return;
      revealInitialized.add(root);

      if (prefersReducedMotion()) {
        root.classList.add('is-in-view');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-in-view');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[entries.length - 1];
          if (!entry?.isIntersecting || entry.intersectionRatio < 0.12) return;
          root.classList.add('is-in-view');
          observer.disconnect();
        },
        { threshold: [0, 0.12, 0.2], rootMargin: '0px 0px -6% 0px' }
      );

      observer.observe(root);
    };

    const initAll = () => {
      const roots = document.querySelectorAll('[data-us-about-section]');
      for (const root of roots) {
        initAboutReveal(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    const handleSectionUpdate = (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      const roots = event.target.querySelectorAll('[data-us-about-section]');
      if (roots.length === 0) return;

      for (const root of roots) {
        revealInitialized.delete(root);
        root.classList.remove('is-in-view');
        initAboutReveal(root);
      }
    };

    document.addEventListener('shopify:section:load', handleSectionUpdate);
    document.addEventListener('shopify:section:reorder', handleSectionUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initialized = new WeakSet();
    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);

      if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
        root.classList.add('is-in-view');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[entries.length - 1];
          if (!entry?.isIntersecting || entry.intersectionRatio < 0.08) return;
          root.classList.add('is-in-view');
          observer.disconnect();
        },
        { threshold: [0, 0.08, 0.15], rootMargin: '0px 0px -6% 0px' }
      );
      observer.observe(root);
    };

    const initAll = () => {
      for (const root of document.querySelectorAll('[data-us-blog-section]')) init(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      for (const root of event.target.querySelectorAll('[data-us-blog-section]')) {
        initialized.delete(root);
        root.classList.remove('is-in-view');
        init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-collection-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const revealInitialized = new WeakSet();

    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initBannerReveal = (root) => {
      if (revealInitialized.has(root)) return;
      revealInitialized.add(root);

      if (prefersReducedMotion()) {
        root.classList.add('is-in-view');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-in-view');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[entries.length - 1];
          if (!entry?.isIntersecting || entry.intersectionRatio < 0.12) return;
          root.classList.add('is-in-view');
          observer.disconnect();
        },
        { threshold: [0, 0.12, 0.2], rootMargin: '0px 0px -6% 0px' }
      );

      observer.observe(root);
    };

    const initAll = () => {
      const roots = document.querySelectorAll('[data-us-collection-banner-section]');
      for (const root of roots) {
        initBannerReveal(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    const handleSectionUpdate = (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      const roots = event.target.querySelectorAll('[data-us-collection-banner-section]');
      if (roots.length === 0) return;

      for (const root of roots) {
        revealInitialized.delete(root);
        root.classList.remove('is-in-view');
        initBannerReveal(root);
      }
    };

    document.addEventListener('shopify:section:load', handleSectionUpdate);
    document.addEventListener('shopify:section:reorder', handleSectionUpdate);
    document.addEventListener('shopify:block:select', handleSectionUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-collection-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initialized = new WeakSet();
    const revealInitialized = new WeakSet();

    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initCollectionSliderReveal = (root) => {
      if (revealInitialized.has(root)) return;
      revealInitialized.add(root);

      if (prefersReducedMotion()) {
        root.classList.add('is-in-view');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-in-view');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[entries.length - 1];
          if (!entry?.isIntersecting || entry.intersectionRatio < 0.12) return;
          root.classList.add('is-in-view');
          observer.disconnect();
        },
        { threshold: [0, 0.12, 0.2], rootMargin: '0px 0px -8% 0px' }
      );

      observer.observe(root);
    };

    const getMaxScroll = (strip) => Math.max(0, strip.scrollWidth - strip.clientWidth);
    const initCollectionSlider = (root) => {
      const alignBreakpoint = Number.parseInt(root.dataset.alignBreakpoint, 10) || 860;
      const strip = root.querySelector('[data-collection-slider-strip]');
      const track = root.querySelector('[data-collection-slider-track]');
      const prevButton = root.querySelector('[data-collection-slider-prev]');
      const nextButton = root.querySelector('[data-collection-slider-next]');

      if (!strip || !track || initialized.has(strip)) return;
      initialized.add(strip);

      let initialScroll = 0;
      let basePaddingStart = 0;

      const getTrackGap = () =>
        Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 32;

      const getStepDistance = () => {
        const slide = track.querySelector('.collection-slider-box');
        if (!slide) return strip.clientWidth * 0.85;
        return slide.offsetWidth + getTrackGap();
      };

      const getPeekWidth = (second) => {
        if (!second) return 0;
        return Math.min(Math.round(second.offsetWidth * 0.22), 140, second.offsetWidth);
      };

      const getBoxes = () => track.querySelectorAll('.collection-slider-box');

      const readBasePaddingStart = () => {
        track.style.removeProperty('padding-inline-start');
        basePaddingStart = Number.parseFloat(getComputedStyle(track).paddingInlineStart) || 0;
      };

      const useRightAlign = () => strip.clientWidth >= alignBreakpoint;

      const applyInitialAlignment = () => {
        readBasePaddingStart();

        const boxes = getBoxes();
        if (boxes.length < 2 || !useRightAlign()) {
          strip.scrollLeft = 0;
          initialScroll = 0;
          return;
        }

        const first = boxes[0];
        const second = boxes[1];
        const gap = getTrackGap();
        const peek = getPeekWidth(second);
        const scrollTarget = Math.round(first.offsetLeft + first.offsetWidth + gap + peek - strip.clientWidth);

        if (scrollTarget <= 0) {
          const alignPad = Math.max(
            0,
            Math.round(strip.clientWidth - first.offsetWidth - gap - peek - basePaddingStart)
          );
          track.style.paddingInlineStart = `${basePaddingStart + alignPad}px`;
          strip.scrollLeft = 0;
          initialScroll = 0;
          return;
        }

        strip.scrollLeft = Math.min(scrollTarget, getMaxScroll(strip));
        initialScroll = strip.scrollLeft;
      };

      const getEndScroll = () => {
        const boxes = track.querySelectorAll('.collection-slider-box');
        const last = boxes[boxes.length - 1];
        if (!last) return 0;
        const maxScroll = getMaxScroll(strip);
        const target = last.offsetLeft + last.offsetWidth - strip.clientWidth;
        return Math.max(0, Math.min(Math.round(target), maxScroll));
      };

      const isAtInitial = () => Math.abs(strip.scrollLeft - initialScroll) <= 2;

      const updateNavState = () => {
        const atStart = isAtInitial();
        const maxScroll = getMaxScroll(strip);
        const endScroll = getEndScroll();
        const atEnd = !atStart && (strip.scrollLeft >= endScroll - 2 || strip.scrollLeft >= maxScroll - 2);

        if (prevButton) prevButton.disabled = atStart;
        if (nextButton) nextButton.disabled = atEnd;
      };

      const alignTrack = () => {
        requestAnimationFrame(() => {
          applyInitialAlignment();
          updateNavState();
        });
      };

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          strip.scrollBy({ left: -getStepDistance(), behavior: 'smooth' });
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          strip.scrollBy({ left: getStepDistance(), behavior: 'smooth' });
        });
      }

      strip.addEventListener('scroll', updateNavState, { passive: true });

      let isDown = false;
      let startX = 0;
      let scrollStart = 0;

      strip.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') return;
        if (event.target.closest('a, button')) return;
        isDown = true;
        startX = event.clientX;
        scrollStart = strip.scrollLeft;
        strip.setPointerCapture?.(event.pointerId);
      });

      strip.addEventListener('pointermove', (event) => {
        if (!isDown) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 4) strip.classList.add('is-dragging');
        strip.scrollLeft = scrollStart - delta;
      });

      const endDrag = (event) => {
        if (!isDown) return;
        isDown = false;
        strip.releasePointerCapture?.(event.pointerId);
        if (strip.classList.contains('is-dragging')) {
          requestAnimationFrame(() => strip.classList.remove('is-dragging'));
        }
        updateNavState();
      };

      strip.addEventListener('pointerup', endDrag);
      strip.addEventListener('pointercancel', endDrag);
      strip.addEventListener('pointerleave', endDrag);

      alignTrack();
      window.addEventListener('resize', alignTrack);
    };

    const initAll = () => {
      const roots = document.querySelectorAll('[data-us-collection-slider-section]');
      for (const root of roots) {
        initCollectionSliderReveal(root);
        initCollectionSlider(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    const handleSectionUpdate = (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      const roots = event.target.querySelectorAll('[data-us-collection-slider-section]');
      if (roots.length === 0) return;

      for (const root of roots) {
        const strip = root.querySelector('[data-collection-slider-strip]');
        if (strip) initialized.delete(strip);
        revealInitialized.delete(root);
        root.classList.remove('is-in-view');
        initCollectionSliderReveal(root);
        initCollectionSlider(root);
      }
    };

    document.addEventListener('shopify:section:load', handleSectionUpdate);
    document.addEventListener('shopify:section:reorder', handleSectionUpdate);
    document.addEventListener('shopify:block:select', handleSectionUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initialized = new WeakSet();

    /* ── Conditional company field ─────────────────────────────────────── */

    const syncCompanyField = (select) => {
      const form = select.closest('form');
      if (!form) return;

      const field = form.querySelector('[data-us-contact-company]');
      const input = form.querySelector('[data-us-contact-company-input]');
      if (!field || !input) return;

      const option = select.options[select.selectedIndex];
      const isTrade = Boolean(option && option.hasAttribute('data-b2b'));

      // CSS already hides the field via :has() so it works without JS. The
      // `hidden` attribute covers browsers without :has(); `disabled` keeps an
      // empty Firma line out of the contact email.
      field.hidden = !isTrade;
      input.disabled = !isTrade;
      if (!isTrade) input.value = '';
    };

    /* ── Custom select ─────────────────────────────────────────────────── */

    const enhanceSelect = (root) => {
      const native = root.querySelector('select');
      const trigger = root.querySelector('[data-us-select-trigger]');
      const panel = root.querySelector('[data-us-select-panel]');
      const value = root.querySelector('[data-us-select-value]');
      if (!native || !trigger || !panel || !value) return;

      const options = [...panel.querySelectorAll('[role="option"]')];
      if (options.length === 0) return;

      const placeholder = value.textContent.trim();
      let activeIndex = -1;
      let typeahead = '';
      let typeaheadTimeout = null;

      const label = root.closest('.us-contact__field')?.querySelector('label');
      if (label) label.htmlFor = trigger.id;

      root.classList.add('is-enhanced');
      trigger.hidden = false;
      native.tabIndex = -1;
      native.setAttribute('aria-hidden', 'true');

      const isOpen = () => trigger.getAttribute('aria-expanded') === 'true';

      const syncFromNative = () => {
        const selected = native.value;

        for (const option of options) {
          option.setAttribute('aria-selected', String(option.dataset.value === selected));
        }

        if (selected) {
          value.textContent = selected;
          delete value.dataset.placeholder;
        } else {
          value.textContent = placeholder;
          value.dataset.placeholder = '';
        }
      };

      const setActive = (index) => {
        if (activeIndex >= 0 && options[activeIndex]) {
          options[activeIndex].classList.remove('is-active');
        }

        activeIndex = index;

        const option = options[activeIndex];
        if (!option) {
          trigger.removeAttribute('aria-activedescendant');
          return;
        }

        option.classList.add('is-active');
        trigger.setAttribute('aria-activedescendant', option.id);
        option.scrollIntoView({ block: 'nearest' });
      };

      const position = () => {
        const spaceBelow = window.innerHeight - trigger.getBoundingClientRect().bottom;
        panel.classList.toggle('us-select__panel--above', spaceBelow < panel.offsetHeight + 16);
      };

      const open = () => {
        if (isOpen()) return;

        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        position();

        const selectedIndex = options.findIndex((option) => option.getAttribute('aria-selected') === 'true');
        setActive(selectedIndex >= 0 ? selectedIndex : 0);
      };

      const close = ({ focusTrigger = false } = {}) => {
        if (!isOpen()) return;

        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        setActive(-1);
        if (focusTrigger) trigger.focus();
      };

      const commit = (index) => {
        const option = options[index];
        if (!option) return;

        native.value = option.dataset.value;
        native.dispatchEvent(new Event('change', { bubbles: true }));
        syncFromNative();
        close({ focusTrigger: true });
      };

      const moveActive = (delta) => {
        const next = Math.min(options.length - 1, Math.max(0, activeIndex + delta));
        setActive(next);
      };

      const search = (key) => {
        clearTimeout(typeaheadTimeout);
        typeahead += key.toLowerCase();
        typeaheadTimeout = setTimeout(() => {
          typeahead = '';
        }, 600);

        const match = options.findIndex((option) => option.dataset.value.toLowerCase().startsWith(typeahead));
        if (match >= 0) setActive(match);
      };

      trigger.addEventListener('click', () => {
        if (isOpen()) close();
        else open();
      });

      trigger.addEventListener('keydown', (event) => {
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            if (isOpen()) moveActive(1);
            else open();
            break;
          case 'ArrowUp':
            event.preventDefault();
            if (isOpen()) moveActive(-1);
            else open();
            break;
          case 'Home':
            if (!isOpen()) break;
            event.preventDefault();
            setActive(0);
            break;
          case 'End':
            if (!isOpen()) break;
            event.preventDefault();
            setActive(options.length - 1);
            break;
          case 'PageDown':
            if (!isOpen()) break;
            event.preventDefault();
            moveActive(5);
            break;
          case 'PageUp':
            if (!isOpen()) break;
            event.preventDefault();
            moveActive(-5);
            break;
          case 'Enter':
          case ' ':
            event.preventDefault();
            if (isOpen()) commit(activeIndex);
            else open();
            break;
          case 'Escape':
            if (!isOpen()) break;
            event.preventDefault();
            close({ focusTrigger: true });
            break;
          case 'Tab':
            close();
            break;
          default:
            if (event.key.length === 1 && !event.metaKey && !event.ctrlKey && !event.altKey) {
              if (!isOpen()) open();
              search(event.key);
            }
        }
      });

      for (const [index, option] of options.entries()) {
        option.addEventListener('click', () => commit(index));
        option.addEventListener('mousemove', () => {
          if (index !== activeIndex) setActive(index);
        });
      }

      document.addEventListener('pointerdown', (event) => {
        if (!isOpen()) return;
        if (!root.contains(event.target)) close();
      });

      // The panel is anchored to the field, so scrolling only needs a fresh
      // flip check — no need to close it.
      window.addEventListener('resize', () => close());
      window.addEventListener('scroll', () => { if (isOpen()) position(); }, { passive: true });

      // Keep the trigger in step when the value changes elsewhere (form reset,
      // autofill, the theme editor re-rendering the section).
      native.addEventListener('change', syncFromNative);
      syncFromNative();
    };

    /* ── Wiring ────────────────────────────────────────────────────────── */

    const initAll = () => {
      for (const select of document.querySelectorAll('[data-us-contact-topic]')) {
        syncCompanyField(select);
        if (initialized.has(select)) continue;

        initialized.add(select);
        select.addEventListener('change', () => syncCompanyField(select));
      }

      for (const root of document.querySelectorAll('[data-us-select]')) {
        if (initialized.has(root)) continue;

        initialized.add(root);
        enhanceSelect(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      if (event.target.querySelector('[data-us-contact-topic]')) initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-history"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const revealInitialized = new WeakSet();

    const prefersReducedMotion = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initHistoryReveal = (root) => {
      if (revealInitialized.has(root)) return;
      revealInitialized.add(root);

      if (prefersReducedMotion()) {
        root.classList.add('is-in-view');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-in-view');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[entries.length - 1];
          if (!entry?.isIntersecting || entry.intersectionRatio < 0.1) return;
          root.classList.add('is-in-view');
          observer.disconnect();
        },
        { threshold: [0, 0.1, 0.18], rootMargin: '0px 0px -8% 0px' }
      );

      observer.observe(root);
    };

    const initAll = () => {
      const roots = document.querySelectorAll('[data-us-history-section]');
      for (const root of roots) {
        initHistoryReveal(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    const handleSectionUpdate = (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      const roots = event.target.querySelectorAll('[data-us-history-section]');
      if (roots.length === 0) return;

      for (const root of roots) {
        revealInitialized.delete(root);
        root.classList.remove('is-in-view');
        initHistoryReveal(root);
      }
    };

    document.addEventListener('shopify:section:load', handleSectionUpdate);
    document.addEventListener('shopify:section:reorder', handleSectionUpdate);
    document.addEventListener('shopify:block:select', handleSectionUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const revealInitialized = new WeakSet();

    const prefersReducedMotion = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initProductListReveal = (root) => {
      if (revealInitialized.has(root)) return;
      revealInitialized.add(root);

      if (prefersReducedMotion()) {
        root.classList.add('is-in-view');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-in-view');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[entries.length - 1];
          if (!entry?.isIntersecting || entry.intersectionRatio < 0.1) return;
          root.classList.add('is-in-view');
          observer.disconnect();
        },
        { threshold: [0, 0.1, 0.18], rootMargin: '0px 0px -8% 0px' }
      );

      observer.observe(root);
    };

    const initAll = () => {
      const roots = document.querySelectorAll('[data-us-product-list-section]');
      for (const root of roots) {
        initProductListReveal(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    const handleSectionUpdate = (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      const roots = event.target.querySelectorAll('[data-us-product-list-section]');
      if (roots.length === 0) return;

      for (const root of roots) {
        revealInitialized.delete(root);
        root.classList.remove('is-in-view');
        initProductListReveal(root);
      }
    };

    document.addEventListener('shopify:section:load', handleSectionUpdate);
    document.addEventListener('shopify:section:reorder', handleSectionUpdate);
    document.addEventListener('shopify:block:select', handleSectionUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-usp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initialized = new WeakSet();
    const stripState = new WeakMap();
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const PIXELS_PER_SECOND = 45;
    const RESUME_DELAY_MS = 2500;
    let rafId = null;
    let lastFrameTime = 0;

    const getLoopWidth = (strip) => {
      const set = strip.querySelector('[data-us-usp-set]:not([data-us-usp-clone])');
      const track = strip.querySelector('[data-us-usp-track]');
      if (!set || !track) return 0;

      const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return set.offsetWidth + gap;
    };

    const normalizeScroll = (strip) => {
      const loopWidth = getLoopWidth(strip);
      if (loopWidth <= 0) return;

      while (strip.scrollLeft >= loopWidth) {
        strip.scrollLeft -= loopWidth;
      }

      while (strip.scrollLeft < 0) {
        strip.scrollLeft += loopWidth;
      }
    };

    const pauseAutoplay = (strip, resumeDelay = RESUME_DELAY_MS) => {
      const state = stripState.get(strip);
      if (!state) return;

      state.isPaused = true;
      clearTimeout(state.resumeTimeout);

      if (resumeDelay > 0) {
        state.resumeTimeout = setTimeout(() => {
          state.isPaused = false;
        }, resumeDelay);
      }
    };

    const tick = (time) => {
      if (!lastFrameTime) lastFrameTime = time;
      const delta = Math.min(time - lastFrameTime, 32);
      lastFrameTime = time;

      if (mobileQuery.matches && !reducedMotionQuery.matches) {
        const strips = document.querySelectorAll('[data-us-usp-strip]');

        for (const strip of strips) {
          const state = stripState.get(strip);
          if (!state || state.isPaused || state.isDragging) continue;

          const loopWidth = getLoopWidth(strip);
          if (loopWidth <= strip.clientWidth) continue;

          state.isProgrammaticScroll = true;
          strip.scrollLeft += (PIXELS_PER_SECOND * delta) / 1000;
          normalizeScroll(strip);

          requestAnimationFrame(() => {
            state.isProgrammaticScroll = false;
          });
        }
      }

      rafId = requestAnimationFrame(tick);
    };

    const ensureAutoplayLoop = () => {
      if (rafId != null) return;
      lastFrameTime = 0;
      rafId = requestAnimationFrame(tick);
    };

    const initStrip = (strip) => {
      if (initialized.has(strip)) return;
      initialized.add(strip);

      const state = {
        isPaused: false,
        isDragging: false,
        isProgrammaticScroll: false,
        resumeTimeout: null,
      };
      stripState.set(strip, state);

      let isDown = false;
      let startX = 0;
      let scrollStart = 0;

      strip.addEventListener(
        'scroll',
        () => {
          if (state.isProgrammaticScroll) return;
          if (!mobileQuery.matches) return;

          normalizeScroll(strip);
          pauseAutoplay(strip);
        },
        { passive: true }
      );

      strip.addEventListener(
        'touchstart',
        () => {
          if (!mobileQuery.matches) return;
          state.isDragging = true;
          pauseAutoplay(strip, 0);
        },
        { passive: true }
      );

      strip.addEventListener(
        'touchend',
        () => {
          if (!mobileQuery.matches) return;
          state.isDragging = false;
          pauseAutoplay(strip);
        },
        { passive: true }
      );

      strip.addEventListener(
        'touchcancel',
        () => {
          if (!mobileQuery.matches) return;
          state.isDragging = false;
          pauseAutoplay(strip);
        },
        { passive: true }
      );

      strip.addEventListener('pointerdown', (event) => {
        if (mobileQuery.matches || event.pointerType !== 'mouse') return;

        isDown = true;
        startX = event.clientX;
        scrollStart = strip.scrollLeft;
        strip.setPointerCapture?.(event.pointerId);
      });

      strip.addEventListener('pointermove', (event) => {
        if (!isDown) return;

        const delta = event.clientX - startX;
        if (Math.abs(delta) > 4) strip.classList.add('is-dragging');
        strip.scrollLeft = scrollStart - delta;
      });

      const endDrag = (event) => {
        if (!isDown) return;

        isDown = false;
        strip.releasePointerCapture?.(event.pointerId);

        if (strip.classList.contains('is-dragging')) {
          requestAnimationFrame(() => strip.classList.remove('is-dragging'));
        }
      };

      strip.addEventListener('pointerup', endDrag);
      strip.addEventListener('pointercancel', endDrag);
      strip.addEventListener('pointerleave', endDrag);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[entries.length - 1];
            if (!entry) return;

            if (entry.isIntersecting) {
              clearTimeout(state.resumeTimeout);
              state.isPaused = false;
            } else {
              pauseAutoplay(strip, 0);
            }
          },
          { threshold: 0.1 }
        );
        observer.observe(strip);
      }
    };

    const initAll = () => {
      const strips = document.querySelectorAll('[data-us-usp-strip]');
      for (const strip of strips) {
        initStrip(strip);

        if (!mobileQuery.matches) {
          const state = stripState.get(strip);
          if (state) {
            state.isPaused = true;
          }
          strip.scrollLeft = 0;
        }
      }
      ensureAutoplayLoop();
    };

    const handleBreakpointChange = () => {
      const strips = document.querySelectorAll('[data-us-usp-strip]');
      for (const strip of strips) {
        const state = stripState.get(strip);
        if (!state) continue;

        strip.scrollLeft = 0;
        state.isPaused = !mobileQuery.matches || reducedMotionQuery.matches;
        state.isDragging = false;
        strip.classList.remove('is-dragging');
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    window.addEventListener('resize', handleBreakpointChange);

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', handleBreakpointChange);
    }

    if (reducedMotionQuery.addEventListener) {
      reducedMotionQuery.addEventListener('change', handleBreakpointChange);
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      if (event.target.querySelector('[data-us-usp-strip]')) initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
